<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
       :stroke="stroke" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7.5"/>
    <path d="M7 11L10 8L7 5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

</template>

<script>
export default {
  name: "ArrowRightCircleIcon",
  props: {
    stroke: {
      type: String,
      default: '#3A913F'
    },
  }
}
</script>
